import {last} from 'lodash';

import {readApiModel} from '../../libs/shared/core/src/helpers/api/apiHelpers';
import {reportToBugsnag} from '../../libs/shared/core/src/services/bugsnag/bugsnag';
import {
  ApiOpenSidebarPluginLinkParameters,
  OpenSidebarPluginLinkParameters,
  serializeOpenSidebarPluginLinkParameters,
} from '../models/api/openSidebarPluginLinkModel';

export const openSidebarPluginLinkPrefix = 'open-sidebar-plugin';

export function tryParseOpenSidebarPluginLink(link: string): OpenSidebarPluginLinkParameters | undefined {
  if (!link.startsWith(openSidebarPluginLinkPrefix)) {
    return undefined;
  }

  const payload = last(link.split('/'));
  if (!payload) {
    return undefined;
  }

  try {
    const src = JSON.parse(decodeURIComponent(payload));
    return readApiModel(ApiOpenSidebarPluginLinkParameters, src);
  } catch (e) {
    reportToBugsnag(new Error(`Failed to parse open sidebar plugin link: ${link}`));
    return undefined;
  }
}

export function buildOpenSidebarPluginPath(parameters: OpenSidebarPluginLinkParameters): string {
  const payload = serializeOpenSidebarPluginLinkParameters(parameters);
  return `${openSidebarPluginLinkPrefix}/${encodeURIComponent(JSON.stringify(payload))}`;
}
